import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { VictoryChart, VictoryLegend, VictoryAxis, VictoryStack, VictoryBar, VictoryLabel, VictoryVoronoiContainer, } from 'victory';
import moment from 'moment-timezone';
import { getHourMinSec, roundOff } from 'globals/global.functions';
import { DATE_FORMAT_SHORT } from 'globals/global.constants';
import { Box, useTheme } from '@mui/material';
var ActivityChart = function (_a) {
    var activityChartData = _a.activityChartData, currentState = _a.currentState, maxDomain = _a.maxDomain;
    var theme = useTheme();
    var legendChartData = [
        {
            name: 'Moderate',
            symbol: { fill: theme.palette.customColor.moderateGreen, type: 'square' },
        },
        {
            name: 'Intense',
            symbol: { fill: theme.palette.customColor.intenseGreen, type: 'square' },
        },
    ];
    return (_jsx(Box, { mt: -5, mb: -5, children: _jsxs(VictoryChart, { domainPadding: { x: activityChartData[0].length > 2 ? 50 : 500, y: 20 }, maxDomain: { y: currentState == 'day' ? maxDomain + 10 : maxDomain + 30 }, width: 1000, height: 435, containerComponent: _jsx(VictoryVoronoiContainer, { activateLabels: true, labels: function (data) {
                    return data;
                }, labelComponent: _jsx(Tooltip, { data: activityChartData, currentState: currentState }) }), children: [_jsx(VictoryLegend, { orientation: 'horizontal', x: 350, y: 5, data: legendChartData }), _jsx(VictoryAxis, { orientation: 'bottom', style: {
                        axis: {
                            stroke: theme.palette.customColor.borderGrey, //CHANGE COLOR OF Y-AXIS
                        },
                    }, tickFormat: function (data) {
                        return moment(data).format(currentState == 'day' ? 'LT' : DATE_FORMAT_SHORT);
                    }, fixLabelOverlap: true }), _jsx(VictoryAxis, { orientation: 'right', dependentAxis: true, style: {
                        axis: {
                            stroke: theme.palette.customColor.borderGrey, //CHANGE COLOR OF Y-AXIS
                        },
                    }, 
                    //tickValues={currentState == 'day' ? [] : yTicks}
                    minDomain: { y: 0 }, maxDomain: { y: 40 }, tickFormat: function (data) {
                        return currentState == 'day' ? data : roundOff(data / 60);
                    }, label: currentState == 'day' ? 'Minutes' : 'Hours', axisLabelComponent: _jsx(VictoryLabel, { angle: 0, dy: -200, dx: -20, style: {
                            fontWeight: 600,
                            fontSize: 15,
                            fill: theme.palette.customColor.titleBlack,
                        } }) }), _jsx(VictoryStack, { colorScale: [
                        theme.palette.customColor.moderateGreen,
                        theme.palette.customColor.intenseGreen,
                    ], children: activityChartData.map(function (chartData) { return (_jsx(VictoryBar, { style: { data: chartData.length > 2 ? {} : { width: 30 } }, data: chartData }, chartData.x + chartData.y)); }) })] }) }));
};
var Tooltip = function (props) {
    var _a, _b;
    var theme = useTheme();
    var x = props.x, data = props.data, datum = props.datum, currentState = props.currentState;
    var width = 150;
    var date = datum === null || datum === void 0 ? void 0 : datum.x;
    if (!date)
        return null;
    var moderate = 0;
    var intense = 0;
    var isNullPoint = false;
    if (data === null || data === void 0 ? void 0 : data.length) {
        var moderateSeries = data[0].find(function (d) { return d.x === date; });
        var intenseSeries = data[1].find(function (d) { return d.x === date; });
        moderate = (_a = moderateSeries === null || moderateSeries === void 0 ? void 0 : moderateSeries.y) !== null && _a !== void 0 ? _a : 0;
        intense = (_b = intenseSeries === null || intenseSeries === void 0 ? void 0 : intenseSeries.y) !== null && _b !== void 0 ? _b : 0;
        // If original duration was null
        if (moderateSeries === null || moderateSeries === void 0 ? void 0 : moderateSeries.isNull) {
            isNullPoint = true;
        }
    }
    // Completely hide tooltip when duration is null
    if (isNullPoint)
        return null;
    return (_jsxs("g", { transform: "translate(".concat(x - width / 2, ", 0)"), children: [_jsx("rect", { height: 65, width: width, fill: theme.palette.background.green, rx: 4 }), _jsx("text", { dx: 10, dy: 18, fontSize: 14, fill: theme.palette.customColor.info, children: moment(date).format(currentState === 'day' ? 'LT' : 'MMMM D') }), _jsx("circle", { cx: 12, cy: 35, r: 5, fill: theme.palette.customColor.moderateGreen }), _jsxs("text", { dx: 22, dy: 39, fontSize: 12, children: ["MODERATE", _jsx("tspan", { dx: 8, children: getHourMinSec(moderate, 'm', 'short') })] }), _jsx("circle", { cx: 12, cy: 52, r: 5, fill: theme.palette.customColor.intenseGreen }), _jsxs("text", { dx: 22, dy: 56, fontSize: 12, children: ["INTENSE", _jsx("tspan", { dx: 18, children: getHourMinSec(intense, 'm', 'short') })] })] }));
};
export { ActivityChart };
